export default function imageLoader(symbol) {
  var url;
  switch (symbol) {
    default:
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528607/coin_ictvlo.svg";
        break;
    case 'BTC':
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521738/btc_x9izvo.svg";
        break;
    case "ETH":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521766/eth_xbfzqk.svg";
        break;
    case "XRP":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521883/xrp_sdeobe.svg";
        break;
    case "BCH":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521729/bch_ec2ocx.svg";
        break;
    case "LTC":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521797/ltc_cfu6z3.svg";
        break;
    case "ADA":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521725/ada_sdn7nw.svg";
        break;
    case "NEO":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521532889/NEO-logo_nw9bgd.svg";
        break;
    case "XLM":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521882/xlm_kxldzb.svg";
        break;
    case "EOS":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521763/eos_pxtlha.svg";
        break;
    case "MIOTA":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521800/miota_ustrnd.svg";
        break;
    case 'XMR':
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521881/xmr_pyppto.svg";
        break;
    case "DASH":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521749/dash_rcqlz5.svg";
        break;
    case "XEM":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521880/xem_l17tu8.svg";
        break;
    case "USDT":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521873/usdt_ulqxas.svg";
        break;
    case "TRX":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521870/trx_tmy3mj.svg";
        break;
    case "VEN":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521873/ven_oxdwfk.svg";
        break;
    case "ETC":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521766/etc_pbohyd.svg";
        break;
    case "QTUM":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521826/qtum_ry8ozq.svg";
        break;
    case "LSK":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521796/lsk_rai0vd.svg";
        break;
    case "OMG":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521813/omg_kzya9t.svg";
        break;
    case "NANO":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521523813/nano_kutbqk.svg";
        break;
    case "BTG":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521524114/btg_vluqnd.svg";
        break;
    case "BNB":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521524218/bnb_cz2dna.svg";
        break;
    case "ICX":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521524295/ICX_lmjebd.svg";
        break;
    case "ZEC":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521521887/zec_prjuhu.svg";
        break;
    case "DGD":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521524486/dgd_no0zgd.svg";
        break;
    case "PPT":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521524589/ppt_dgb3sb.svg";
        break;
    case "STEEM":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521524620/steem_s8nlkl.svg";
        break;
    case "BCN":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521524709/bcn_kx830r.svg";
        break;
    case "WAVES":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525085/waves_gah3fu.svg";
        break;
    case "STRAT":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525124/strat_elunpb.svg";
        break;
    case "XVG":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525180/xvg_l9ipu2.svg";
        break;
    case "MKR":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525223/mkr_nxqcg4.svg";
        break;
    case "BTS":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525265/bts_afspug.svg";
        break;
    case "DOGE":
        url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525301/doge_fpk7cq.svg";
        break;

        case 'SNT':
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525355/snt_wkpley.svg";
            break;
        case "RHOC":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525396/rhoc_yutgah.svg";
            break;
        case "SC":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525424/sc_bzujo9.svg";
            break;
        case "AE":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525454/ae_bte8d0.svg";
            break;
        case "REP":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525482/rep_i6w6il.svg";
            break;
        case "DCR":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525528/dcr_r5rae1.svg";
            break;
        case "BTM":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525618/btm_ymob76.svg";
            break;
        case "ONT":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525826/ontology_irqpmc.png";
            break;
        case "WTC":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525875/wtc_cyl785.svg";
            break;
        case "ZIL":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521525948/zil_ruaqjm.svg";
            break;
        case 'AION':
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526025/aion_l93wln.svg";
            break;
        case "KMD":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526059/kmd_lhd4gs.svg";
            break;
        case "ARDR":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526090/ardr_ynfbgy.svg";
            break;
        case "ARK":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526126/ark_v0qlcb.svg";
            break;
        case "CNX":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526154/cnx_gfxhsy.svg";
            break;
        case "HSR":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526218/hsr_ogvb65.svg";
            break;
        case "KCS":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526246/kcs_oipjbc.svg";
            break;
        case "ZRX":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526315/zrx_rxc6yd.svg";
            break;
        case "MONA":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526350/mona_bfhynj.svg";
            break;
        case "GAS":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521532889/NEO-logo_nw9bgd.svg";
            break;
        case "ETN":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526580/etn_sdxggo.svg";
            break;
        case "VERI":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526630/veri_ygoacq.svg";
            break;
        case "PIVX":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526661/pivx_wdeo0m.svg";
            break;
        case "DRGN":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526688/drgn_wlrk4e.svg";
            break;
        case "FCT":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526717/fct_kzujtn.svg";
            break;
        case "R":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526759/r_zaselo.svg";
            break;
        case "SYS":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526799/sys_vzvuup.svg";
            break;
        case "BAT":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526825/bat_r17pwy.svg";
            break;
        case "GNT":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526853/gnt_mslbsm.svg";
            break;
        case "ETHOS":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526883/ethos_vle9n3.svg";
            break;
        case "QASH":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526910/qash_zyoxlf.svg";
            break;
        case "LRC":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526941/lrc_psuexv.svg";
            break;
        case "NAS":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526987/nas_rdliea.svg";
            break;
        case "FUN":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527019/fun_dfhqtd.svg";
            break;
        case "KNC":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527051/knc_eko90v.svg";
            break;
        case "DGB":
            url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521526385/dgb_q4lwah.svg";
            break;

            case "GXS":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527166/gxs_hwamgg.svg";
                break;
            case "XZC":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527220/xzc_wbmnoe.svg";
                break;
            case "RDD":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527252/rdd_pcvlrv.svg";
                break;
            case "IOST":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527276/iost_lxwvib.svg";
                break;
            case "EMC":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527308/emc_txfdtf.svg";
                break;
            case "ELF":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527341/elf_v9s1kp.svg";
                break;
            case "MAID":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527383/maid_xrdnmb.svg";
                break;
            case "NXT":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527422/nxt_fzk2jv.svg";
                break;
            case "KIN":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527468/kin_oh3bty.svg";
                break;
            case "NCASH":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527573/nucleus_trynrf.png";
                break;
            case "SALT":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527645/salt_uw0iaa.svg";
                break;
            case "POWR":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527672/powr_avmjna.svg";
                break;
            case "DCN":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527701/dcn_jdmlpj.svg";
                break;
            case "LINK":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527727/link_oefdfg.svg";
                break;
            case "PART":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527770/part_lwjlps.svg";
                break;
            case "GBYTE":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527797/gbyte_tgiwoq.svg";
                break;
            case "NEBL":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527828/nebl_k7vsd9.svg";
                break;
            case "REQ":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527876/req_nn4xyt.svg";
                break;
            case "SMART":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521527971/smart_pg0cpb.svg";
                break;
            case "BNT":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528007/bnt_gyqffl.svg";
                break;
            case "PAY":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528051/pay_ip7xuk.svg";
                break;
            case "POLY":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528091/poly_sosrgl.svg";
                break;
            case "DENT":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528125/dent_okllyb.svg";
                break;
            case "CND":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528158/cnd_oopzle.svg";
                break;
            case "ICN":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528190/icn_jiwczq.svg";
                break;
            case "NXS":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528219/nxs_z2fekh.svg";
                break;
            case "MNX":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528281/mnx_zwvekv.svg";
                break;
            case "STORJ":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528321/storj_bjhwqy.svg";
                break;
            case "ENG":
                url = "https://res.cloudinary.com/mscmnd-com/image/upload/v1521528374/eng_yxrhte.svg";
      }
    return url
  }



// WEBPACK FOOTER //
// ./src/js/image-loader.js